module.exports = __webpack_public_path__ + "static/img/krp975-653-37074rd.cab04c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/krp975-653-37074rd.jpg
// module id = UiDL
// module chunks = 0